module.exports = {"name":"summaryNodes","source":"nodeTree","transform":[{"type":"filter","expr":"datum.type === 'SummaryNode'"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/data/tree/summary-nodes.json
// module id = Qr3g
// module chunks = 0